import React, { useState } from "react";
import "../styling/FAQ.css";

const FAQ_GROUPS = [
  {
    title: "About PrOCaRe",
    items: [
      {
        tag: "Overview",
        q: "What is PrOCaRe?",
        a: (
          <p>
            PrOCaRe organizes clinical, molecular, treatment, and outcome
            information from published precision oncology case reports.
          </p>
        ),
      },
      {
        tag: "Scope",
        q: "What cases are included?",
        a: (
          <>
            <p>Included cases involve:</p>
            <ul>
              <li>a patient with cancer</li>
              <li>a molecular biomarker-informed treatment decision</li>
              <li>a reported clinical outcome</li>
            </ul>
          </>
        ),
      },
      {
        tag: "Sources",
        q: "Where does the information come from?",
        a: (
          <p>
            All data are extracted from case report articles published under
            Creative Commons licenses or by publishers that explicitly authorize
            this form of use. Each case links back to the original publication.
          </p>
        ),
      },
    ],
  },
  {
    title: "Data & Methodology",
    items: [
      {
        tag: "Workflow",
        q: "How is data curation performed?",
        a: (
          <p>
            PrOCaRe uses a large language model–based workflow to extract,
            normalize, and organize the data.
          </p>
        ),
      },
      {
        tag: "Reliability",
        q: "How reliable is the data curation?",
        a: (
          <p>
            Data are automatically retrieved using a large language model–based
            workflow. Benchmarking shows strong concordance with expert
            interpretation, but individual PrOCaRe entries have not been
            manually reviewed.
          </p>
        ),
      },
      {
        tag: "Limitations",
        q: "What are the main limitations of the data?",
        a: (
          <p>
            The data come from case reports, which may be incomplete,
            selectively reported, or difficult to compare across publications.
          </p>
        ),
      },
    ],
  },
  {
    title: "Usage & Interpretation",
    items: [
      {
        tag: "Clinical use",
        q: "Can PrOCaRe inform clinical questions?",
        a: (
          <p>
            PrOCaRe may help identify published cases with molecular or clinical
            features of interest. Any clinical interpretation should be made by
            qualified professionals in the context of the full clinical scenario
            and other available evidence.
          </p>
        ),
      },
    ],
  },
  {
    title: "Support",
    items: [
      {
        tag: "Feedback",
        q: "How can I report an issue?",
        a: (
          <p>
              Please send an email to 
              <a href="mailto:procare@scilifelab.se"> procare@scilifelab.se</a> 
              with a description of the issue and any relevant details.
          </p>
        ),
      },
    ],
  },
];

export default function FAQ() {
  const [openKey, setOpenKey] = useState("about-procare-0");

  return (
    <main className="faq-page">
      <section className="faq-card-shell">
        <section className="faq-hero">
          <h1>Frequently asked questions</h1>
        </section>

        <section className="faq-warning">
          <strong>Important:</strong> PrOCaRe is intended for exploratory
          research use. Individual entries are automatically curated and have not
          been manually reviewed case-by-case.
          The content of the ProCaRe website is freely available for research, educational, and 
          other non-commercial purposes. Commercial use of the content is not permitted without 
          prior written permission.
        </section>

        <section className="faq-layout">
          {FAQ_GROUPS.map((group) => (
            <section className="faq-group" key={group.title}>

              <div className="faq-card-list">
                {group.items.map((item, index) => {
                  const key = `${group.title
                    .toLowerCase()
                    .replaceAll(" ", "-")}-${index}`;

                  const isOpen = openKey === key;

                  return (
                    <article
                      className={`faq-card ${isOpen ? "is-open" : ""}`}
                      key={key}
                    >
                      <button
                        className="faq-question"
                        onClick={() => setOpenKey(isOpen ? "" : key)}
                        aria-expanded={isOpen}
                      >
                        <span>
                          <span className="faq-tag">{item.tag}</span>
                          <span className="faq-question-text">{item.q}</span>
                        </span>

                        <span className="faq-toggle" aria-hidden="true">
                          {isOpen ? "−" : "+"}
                        </span>
                      </button>

                      <div className="faq-answer-wrap">
                        <div className="faq-answer">{item.a}</div>
                      </div>
                    </article>
                  );
                })}
              </div>
            </section>
          ))}
        </section>
      </section>
    </main>
  );
}